import React from 'react';
import SubPage from '#/common/components/SubPage';
import ShowroomForm from '../ShowroomForm/ShowroomForm';
import type { ShowroomDataType } from '../ShowroomForm/fields';

const ShowroomPage: React.FC = () => {
  const data: ShowroomDataType = {
    __typename: 'ShowroomDataType' as const,
    id: '1',
    tag: 'Test Tag', // This field has a value, so conditional buttons will be enabled
    // DevExtreme components with example data
    autocompleteField: 'Apple',
    calendarField: new Date(),
    checkBoxField: true,
    colorBoxField: '#3498db',
    currencyField: 2500.75,
    dateBoxField: new Date(),
    dateTimeBoxField: new Date(),
    timeBoxField: new Date(),
    dropDownBoxField: 'opt1', // Updated to match the value from the fixed dropdown
    htmlEditorField: '<p><strong>Welcome</strong> to the HTML Editor!</p>',
    imageField: 'https://via.placeholder.com/150/0000FF/808080?text=Sample+Image', // Example image URL
    lookupField: '1',
    numberBoxField: 42,
    radioGroupField: 'Option A',
    rangeSliderField: [25, 75],
    relatedItemsField: '', // Related items field
    selectBoxField: 'Medium',
    sliderField: 60,
    switchField: true,
    tagBoxField: ['React', 'DevExtreme'],
    textAreaField: 'This is a sample\nmulti-line text content\nfor the text area.',
    textBoxField: 'Sample text input',
  };

  return (
    <SubPage type="form" title={'Test Form with Action Buttons'} showGoBackButton>
      <ShowroomForm value={data} />
    </SubPage>
  );
};

export default React.memo(ShowroomPage);
